export default __webpack_public_path__ + "static/media/Heart-page.144777b2.png";